import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconShapeWidescreen = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 16 16"
      data-fill-none
    >
      <rect
        x="0.75"
        y="4.25"
        width="14.5"
        height="7.5"
        rx="1.25"
        stroke="#626266"
        strokeWidth="1.5"
      />
    </SvgIcon>
  ))
);
IconShapeWidescreen.displayName = 'IconShapeWidescreen';
